// DARAT storefront entry (built by `bench build --app darat`).
import { initUI } from "./store/ui";
import { initCart, initCheckout, initCheckoutExtras } from "./store/cart";
import { initSearch } from "./store/search";
import { initChat } from "./store/chat";
import { initMotion, initRum } from "./store/motion-lite";
import { initSelects } from "./store/select";
import { initAutoscroll } from "./store/autoscroll";
import { initShop2 } from "./store/shop";
import { initFeatures } from "./store/features";
import { initLaptop } from "./store/laptop";
import { initTrust } from "./store/trust";
import { initTracking } from "./store/track";
import { initExtras } from "./store/extras";
import { initLookup } from "./store/lookup";
import { initPay } from "./store/pay";
import { initAccount } from "./store/account";

// Interactive essentials first (menus, cart, search, forms), then animation and extras.
// Yielding between steps keeps each task short, so taps are answered while the page boots.
const STEPS = [initSelects, initUI, initPay, initAccount, initCart, initSearch, initCheckoutExtras, initCheckout, initShop2, initLookup,
	initFeatures, initLaptop, initTrust, initChat, initAutoscroll, initMotion, initExtras, initTracking, initRum];
const pause = () => new Promise((r) => (window.scheduler && scheduler.yield ? scheduler.yield().then(r) : setTimeout(r, 0)));

async function boot() {
	for (const step of STEPS) {
		try { step(); } catch (e) { console.error(e); }  // one feature failing never stops the others
		await pause();
	}
}

if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
else boot();
